import { TabBookingAbstract } from '@/components/Cargo/Job/booking/tabs/tabBookingAbstract'
import { ContainerManager } from './containerManager'
import StrUtils from '@/utils/StrUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import { Job } from '@/class/model/booking/Job'
import { TabError } from '@/utils/class/TabError'
import { batchAddJob, batchRemoveJob, checkJobForShared } from '@/api/seaExport/seaExportJob'
import { sortByMultiField } from '@/utils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { splitMaster } from '@/api/railwayExport/reBooking'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export class TabLclContainerBase extends TabBookingAbstract {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.$message = this.view.$message
    this.$confirm = this.view.$confirm
    this.$refs = this.view.$refs
    this.$store = this.view.$store
    this.$i18n = this.view.$i18n
    this.$emit = this.view.$emit
    this.$t = this.view.$t
    this.$checkPermission = this.view.$checkPermission

    this.manager = null
  }

  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }

  //  装箱明细
  get containerUsageColl() {
    return this.view.containerUsageColl
  }
  set containerUsageColl(containerUsageColl) {
    this.view.containerUsageColl = containerUsageColl
  }

  commitProperties() {
    this.refreshContainers()

    //   lclSalve 关联containers的同一usages
    this.refreshSlaveUsageColl()

    this.refreshDatas()
    this.socChange()
  }

  // lclSalve 关联containers的同一usages
  refreshSlaveUsageColl() {
    for (const slave of this.job.lclSlaves) {
      slave.containerUsages = []
    }
    for (const container of this.job.containers) {
      for (const usage of container.containerUsage) {
        const slave = this.job.lclSlaves.find(p => p.uuid === usage.jobUuid)
        if (!slave) {
          continue
        }
        slave.containerUsages.push(usage)
      }
    }
  }
  /**
   * 刷新箱子
   */
  refreshContainers() {
    const job = this.job
    if (!this.manager || !job) { return }

    if (job.containers && job.containers.length > 0) {
      // 默认选中第一行
      this.view.$nextTick(async() => {
        await this.setGridSelect()
        this.containerChangeHandler()
      })
    } else {
      this.refreshUsages()

      // 没有箱子的情况下，重置装箱信息，避免装箱grid 数据未重置
      const container = this.view.selectedContainer
      if (container) {
        container.containerUsage = []
      }
    }
  }
  // 箱子设置 选中行(加载数据后默认选中第一行记录)
  setGridSelect() {
    const nodes = this.view.left.gridOptions.api.getRenderedNodes()
    if (!nodes) {
      return
    }
    // 默认选中第一个
    for (const item of nodes) {
      item.setSelected(true)
      this.view.selectedContainer = item.data
      break
    }
  }

  // 装箱信息 设置 选中行
  setUsageGridSelect(selectedRows) {
    const gridApi = this.view.right.gridApi
    const nodes = gridApi.getRenderedNodes()

    for (const item of nodes) {
      if (selectedRows.findIndex(p => p.jobUuid === item.data.jobUuid) > -1) {
        // item.setSelected(true)
        this.view.right.gridApi.setFocusedCell(item.rowIndex, this.view.right.gridApi.columnController.getAllDisplayedColumns()[0])
      }
    }
  }

  // 箱子grid 选中事件
  containerChangeHandler(event = null) {
    if (event) {
      this.view.selectedContainer = event.data
    }
    this.refreshUsages()
  }

  /**
   * 刷新用量
   */
  refreshUsages() {
    if (!this.manager) { return }
    const container = this.view.selectedContainer
    if (container) {
      this.refreshContainerUsageColl(container)
      if (this.containerUsageColl) {
        let index = 0
        // serialNo 与cargo 写法不同 从最初开始编码
        index = 1
        for (const c of this.containerUsageColl) {
          c.serialNo = index++
        }
        this.view.right.gridOptions.api.refreshCells({ force: true })
      }
      // 排序
      sortByMultiField(this.containerUsageColl, ['serialNo'], false)
      // 改为 push 避免同一引用 多个container引用指向同一个
      container.containerUsage = []
      for (const usage of this.containerUsageColl) {
        container.containerUsage.push(usage)
      }

      this.view.usagesTotalDesc.txtNum = this.$t('Message.Count') + '：' + (this.containerUsageColl == null ? 0 : this.containerUsageColl.length)
    } else {
      this.containerUsageColl = []
      this.view.usagesTotalDesc.txtNum = this.$t('Message.Count') + '：0'
    }

    let quantity = 0
    let weight = 0
    let cubage = 0
    for (const usage of this.containerUsageColl) {
      quantity += Number(usage.quantity)
      weight += Number(usage.weight)
      cubage += Number(usage.cubage)
    }
    this.view.usagesTotalDesc.usageTotalQuantity = String(quantity)
    this.view.usagesTotalDesc.usageTotalWeight = NumberUtils.formatNumber(weight, 3, true)
    this.view.usagesTotalDesc.usageTotalCubage = NumberUtils.formatNumber(cubage, 3, true)

    // 件毛体合计 刷新至箱子上  h5 新增需求，cargo 中无此功能
    container.quantity = quantity
    container.weight = weight
    container.cubage = cubage
  }

  // 装箱件毛体刷新至箱子上 件毛体合计 刷新至箱子上  h5 新增需求，cargo 中无此功能
  refreshContainerQwc() {
    const container = this.view.selectedContainer
    let quantity = 0
    let weight = 0
    let cubage = 0
    for (const usage of container.containerUsage) {
      quantity += Number(usage.quantity)
      weight += Number(usage.weight)
      cubage += Number(usage.cubage)
    }
    this.view.usagesTotalDesc.usageTotalQuantity = String(quantity)
    this.view.usagesTotalDesc.usageTotalWeight = NumberUtils.formatNumber(weight, 3)
    this.view.usagesTotalDesc.usageTotalCubage = NumberUtils.formatNumber(cubage, 3)

    // 件毛体合计 刷新至箱子上  h5 新增需求，cargo 中无此功能
    container.quantity = quantity
    container.weight = weight
    container.cubage = cubage
  }

  refreshContainerUsageColl(container) {
    this.containerUsageColl = []
    for (const usage of container.containerUsage) {
      if (!StrUtils.isEmpty(usage.containerUuid) && !StrUtils.isEmpty(usage.jobUuid)) {
        this.containerUsageColl.push(usage)
      }
    }
  }

  /**
   * 应用各个表格的数据
   */
  refreshDatas() {
    if (!this.job || StrUtils.isEmpty(this.job.uuid)) { return }

    this.manager = new ContainerManager(this.job)
    this.manager.clearRemoveSourceUsages()
    this.refreshSalves()
    this.refreshContainers()
  }

  /**
   * 刷新小票
   */
  refreshSalves() {
    const manager = this.manager
    if (!manager) { return }
    this.view.lclSlaves = manager.getUnboxedSlaves()
    let quantity = 0
    var weight = 0
    let cubage = 0
    for (const slave of this.view.lclSlaves) {
      quantity += slave.quantityActual
      weight += slave.weightActual
      cubage += slave.cubageActual
    }
    this.view.slaveTotalDesc.slaveTotalQuantity = String(quantity)
    this.view.slaveTotalDesc.slaveTotalWeight = NumberUtils.formatNumber(weight, 3, true)
    this.view.slaveTotalDesc.slaveTotalCubage = NumberUtils.formatNumber(cubage, 3, true)
  }

  socChange() {
    // soc 改变同步箱子usage 的 soc
    // 已在 seaEqDataGrid 中实现
  }

  // 加入小票
  async addSlaveHandler() {
    if (!await SecurityUtil.canOPEditWithAlert(this.job)) {
      return
    }
    this.view.querySELclDialog.visible = true
  }

  slaveAddedHandler(rows) {
    batchAddJob(rows, this.job.uuid, this.job.mbl, this.view.location).then(res => {
      if (res.data && res.data.length > 0) {
        for (const item of rows) {
          item.lclMasterUuid = this.job.uuid
          item.mbl = this.job.mbl
          item.version = item.version + 1
          if (!this.job.lclSlaves) {
            this.job.lclSlaves = []
          }
          this.job.lclSlaves.push(item)
        }
        this.view.lclSlaves = this.job.lclSlaves
        this.refreshSlaveUsageColl()
        this.view.$emit('addSlavedJob', rows)
        this.refreshSalves()
      }
    })
  }

  // 移除小票
  removeSlaveHandler() {
    if (!this.view.selectedSlave.uuid) { return }

    this.$confirm(this.$t('Message.AreYouSureYouWantToRemoveTheSubBill'), this.$t('common.tips.prompt'), {
      confirmButtonText: this.$t('common.btn.ok'),
      cancelButtonText: this.$t('common.btn.cancel'),
      type: 'warning'
    }).then(async() => {
      await this.removeSlaveCheckHandler()
    })
  }

  async removeSlaveCheckHandler() {
    const slave = this.view.selectedSlave
    const slaveClass = new Job(slave)
    if (slave.quantityActual !== slaveClass.getUnboxedQuantity() ||
      slave.weightActual !== slaveClass.getUnboxedWeight() ||
      slave.cubageActual !== slaveClass.getUnboxedCubage()) {
      this.$message.warning(this.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeRemoved'))
      return
    }
    slave.lclMaster = null
    // 使用基本tab 的移除小票方法
    const jobKeys = [slave.uuid]
    await checkJobForShared(jobKeys).then(async res => {
      if (res.data) {
        this.view.$message.warning(res.data + this.$message.$t('CargoMsg.Cargo_SmallTicketCannotBeRemoved'))
      } else {
        const loading = getLoading4Cxt(this.view)
        batchRemoveJob(jobKeys, this.view.location).then(res => {
          this.slaveResultHandler(res.data, jobKeys)
        }).finally(() => {
          loading.close()
        })
      }
    })
  }

  slaveResultHandler(num, jobKeys) {
    if (num > 0) {
      this.job.lclSlaves = ''
      new Job(this.job).loadJobRelated({ lclSlaves: true }).then(data => {
        this.job.lclSlaves = data
        this.view.lclSlaves = this.job.lclSlaves
        this.refreshSlaveUsageColl()
      })
      this.view.$emit('removeJobFromMaster', jobKeys)
    }
    this.refreshSalves()
    this.$message.success(this.$t('Message.RemovedSuccesfully'))
  }

  // 装箱
  addToContainerHandler() {
    const slaves = []
    if (this.view.selectedSlave.uuid) {
      slaves.push(this.view.selectedSlave)
    }
    // 避免选择了多个或没有箱子
    const containers = this.view.selectedContainer// this.view.left.gridApi.getSelectedRows()
    if (!containers) {
      this.$message.warning('请选中一个箱子')
      return
    }

    if (slaves.length > 0 && slaves[0]) { this.addToContainer(slaves, this.view.selectedContainer) }
  }

  addToContainer(slaves, container) {
    container.isDirty = true

    const usages = this.manager.multiLoadContainer(slaves, container)
    this.refreshSalves()
    this.refreshUsages()
    // 选中指定行
    this.view.$nextTick(() => {
      this.setUsageGridSelect(usages)
    })

    // 记录 装箱(装箱会改变 removedContainerUsages 中的值) 同cargo中的syncActionItems
    this.syncActionItems()
  }

  // 移除装箱
  removeToContainerHandler() {
    const cell = this.view.right.gridApi.getFocusedCell()
    const node = this.view.right.gridApi.getRenderedNodes()[cell.rowIndex]
    const usages = node ? [node.data] : []
    if (usages.length > 0) { this.removeToContainer(usages) }
  }

  /**
   * 卸载
   */
  removeToContainer(usages) {
    const container = this.view.selectedContainer
    container.isDirty = true

    this.manager.multiUnloadContainer(usages)
    this.refreshSalves()
    this.refreshUsages()

    // 记录 装箱(移除装箱会改变 removedContainerUsages 中的值) 同cargo中的syncActionItems
    this.syncActionItems()
  }

  /**
   * 返回需要同步保存的对象列表
   */
  syncActionItems() {
    this.job.delContainerUsageUuids = []
    for (const item of this.manager.removedContainerUsages) {
      this.job.delContainerUsageUuids.push(item.entity.uuid)
    }
  }
  /**
   * 验证
   */
  validateForm() {
    if (this.manager) {
      const msg = this.manager.validateSlavesUsage()
      if (msg.length > 0) {
        throw new TabError(msg, 'tabLclContainer')
      }
    }
    return true
  }

  /**
   * 拆分主票
   */
  splitClickEventHandler() {
    const mapItem = this.getContainersUsgeJobs()
    const jobList = mapItem['jobList']
    const selectContainerKeys = mapItem['selectContainerKeys']
    if (jobList.length === 0) {
      this.$message.warning(this.$t('Message.NoSubBillsToSplit'))
      return
    }

    this.toSplit(jobList, selectContainerKeys)
  }

  getContainersUsgeJobs() {
    const map = {}
    const jobList = []
    const selectContainerKeys = []

    const selectContainers = this.view.left.gridApi.getSelectedRows()
    if (selectContainers) {
      for (let i = selectContainers.length - 1; i >= 0; i--) {
        const container = selectContainers[i]
        selectContainerKeys.push(container.uuid)
        const containerUsages = container.containerUsage
        for (let j = containerUsages.length - 1; j >= 0; j--) {
          const usge = containerUsages[j]
          if (jobList.indexOf(usge.jobUuid) < 0) {
            jobList.push(usge.jobUuid)
          }
        }
      }
    }
    map['containers'] = selectContainers
    map['selectContainerKeys'] = selectContainerKeys
    map['jobList'] = jobList
    return map
  }
  // 拆分主票
  toSplit(jobKeys, selectContainerKeys) {
    if (jobKeys.length === 0) {
      this.$message.warning(this.$t('Message.NoBusinessCanBeSplit'))
      return
    }
    const params = {
      jobKeys: jobKeys,
      splitPattern: 1, // 拆分模式 0.选择小票拆分 1.按装箱信息拆分
      selectContainerKeys: selectContainerKeys,
      lclMasterKey: this.job.uuid
    }
    splitMaster(params).then(async res => {
      const newSplitJob = res.data
      if (!newSplitJob || !newSplitJob.seaEQ || newSplitJob.seaEQ.length === 0) {
        this.$message.warning(this.$t('Message.SplittingErrorContainerInformationIsEmpty'))
        return
      }

      // 删除原始Job关系seaEq,container
      newSplitJob.delContainerUuids = selectContainerKeys.join(',')
      newSplitJob.sourceSeqEq = this.refSplitMasterSeaEq()
      newSplitJob.beSplitedJobUuid = this.job.uuid
      newSplitJob.beSplitedLclUuids = jobKeys.join(',')

      this.view.$emit('split', newSplitJob)
    })
  }

  /**
   * 更新拆分主票箱型箱重信息(cargo, SplitContainerUtil )
   */
  refSplitMasterSeaEq(eQtype, eQsize) {
    const seqEqData = { delseaEQUuids: [], updateSeaEq: [] }
    const selectContainers = this.view.left.gridApi.getSelectedRows()
    if (selectContainers) {
      for (let i = selectContainers.length - 1; i >= 0; i--) {
        const container = selectContainers[i]

        for (let i = this.job.seaEQ.length - 1; i >= 0; i--) {
          const e = this.job.seaEQ[i]
          if (e.eqType === container.eqType && e.eqSize === container.eqSize) {
            e.eqQuantity = e.eqQuantity - 1
            if (e.eqQuantity <= 0) {
              seqEqData.delseaEQUuids.push(e.uuid)
            } else {
              seqEqData.updateSeaEq.push(e)
            }
            break
          }
        }
      }
    }

    return seqEqData
  }
}
